/*
 *
 * SignUpPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import {StripeProvider} from 'react-stripe-elements';
import {Elements} from 'react-stripe-elements';
import InjectedCheckoutForm from './CheckoutForm';
import { niceChoiceRequest, resetSubscriptionError } from './actions';
import {
  Wrapper,
  Container,
  Heading,
  PriceDetails,
  Autofill,
  ColMd6L,
  ColMd6R,
  Row,
  AutofillActive,
} from './styledComponents';
import { Redirect } from 'react-router';
import H1 from 'components/H1';
import { ToastContainer, toast } from 'react-toastify';

const SubscriptionResponse = ({ success, error, errorOnClose }) => (
  <div>
    {error && toast("Error", { onClose: errorOnClose }) && ''}
    {success && <Redirect to='/channels' />}
  </div>
);
const NiceChoice = ({
  signUpSuccessful,
  onNiceChoiceSubmit,
  planId,
  discount,
  cost,
  subscriptionError,
  subscriptionSuccess,
  resetError,
}) => {
  return (
  <Wrapper>
    <Helmet title='Movebooth | Sign Up' />
      <SubscriptionResponse
        success={subscriptionSuccess}
        error={subscriptionError}
        errorOnClose={resetError} />
      <ToastContainer preventDuplicated />
        <Container>
          <Heading>
            <H1>
             Nice choice.
            </H1>
            Complete the secure checkout below to start making moves with Memento by Movebooth.

          </Heading>
          <PriceDetails>
            <h2>Checkout Summary</h2>
            <Autofill>
              <p>
                <span>{ planId == "memento_lite_annual" ? 'Memento by Movebooth LITE (annual)' : 
                        planId == "memento_unlimited_annual" ? 'Memento by Movebooth UNLIMITED (annual)' :
                        planId == "memento_lite_monthly" ? 'Memento by Movebooth LITE (monthly)' : 'Memento by Movebooth UNLIMITED (monthly)'}
                </span>
                <strong>${cost}</strong>
              </p>{ discount != 0 ?
              <AutofillActive>
                <p>
                  <span>Annual Prepayment Discount</span>
                  <strong>{discount}</strong>
                </p>
              </AutofillActive> : <br/>
              }
            </Autofill>

            <Row>
              <ColMd6L>
                <span>Total Charge</span>
              </ColMd6L>
              <ColMd6R>
                <strong>${cost-discount}</strong>
              </ColMd6R>
            </Row>
          </PriceDetails>
          <StripeProvider apiKey='pk_test_f3dahVTfYUEzcZAyMPMobr5E' >
            <Elements>
              <InjectedCheckoutForm onSubmit={onNiceChoiceSubmit} planId={planId} />
            </Elements>
          </StripeProvider>
        </Container>
  </Wrapper>
);
}
const mapStateToProps = (state) =>({
  subscriptionError:   state.niceChoice.error,
  subscriptionSuccess: state.niceChoice.success,
});
const mapDispatchToProps = (dispatch,ownProps) => ({
  planId: ownProps.match.params.planId,
  cost: ownProps.match.params.cost,
  discount: ownProps.match.params.discount,
  onNiceChoiceSubmit: (data) => dispatch(niceChoiceRequest(data)),
  resetError: () => dispatch(resetSubscriptionError()),
});
export default connect(mapStateToProps, mapDispatchToProps)(NiceChoice);



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/index.js